import { render, staticRenderFns } from "./InsightsLoading.vue?vue&type=template&id=5fa30722&functional=true&"
import script from "./InsightsLoading.vue?vue&type=script&lang=js&"
export * from "./InsightsLoading.vue?vue&type=script&lang=js&"
import style0 from "./InsightsLoading.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports